import React from 'react';
import TransitionFormFields from './TransitionFormFields';
import { transitionSchema } from '../../../lib/transition-schemas';

// ProspectForm — captures restart_reason on backward moves into prospect
// (dormant → prospect, closed_lost → prospect via reverse paths). Avoids
// silent ghost re-entries in the funnel.
export default function ProspectForm({ values, onChange, errors }) {
  return <TransitionFormFields schema={transitionSchema('prospect')} values={values} onChange={onChange} errors={errors} />;
}
